import { SET_LOADING_STATUS } from '../utils/type';

export const displayLoader = (status) => {
  return {
    type: SET_LOADING_STATUS,
    data: status
  };
};
